import { render, staticRenderFns } from "./CheckResultTable.vue?vue&type=template&id=5b16c83c&scoped=true&"
import script from "./CheckResultTable.vue?vue&type=script&lang=js&"
export * from "./CheckResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16c83c",
  null
  
)

export default component.exports